"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var Thing = function Thing(props) {
  return _react["default"].createElement(_TextField["default"], props);
};

var TextArea = (0, _styledComponents["default"])(Thing).withConfig({
  displayName: "TextArea",
  componentId: "sc-1wbvnkd-0"
})(["border-top:24px solid transparent;padding:0px 16px 6px;"]);
Thing.defaultProps = {
  as: "textarea"
};
var _default = TextArea;
exports["default"] = _default;